import { useMemo } from 'react'
import useHouseholdChain from '../../hooks/useHouseholdChain'

/**
 * Meldt dat een andere organisatie hetzelfde huishouden helpt.
 *
 * WAAROM DIT ER IS. In de ketentest van 2026-09-10 bleek de Energiebank nergens
 * te zien dat het BuurtKlusBedrijf op dezelfde woning zat — terwijl de
 * huishoudsleutel die het koppelt er al lag. Dit is de afspraak uit het
 * partneroverleg: laat zien dát het huishouden al bekend is, en sinds wanneer.
 *
 * GEEN NAMEN. De deelname-rij is bewust dun en draagt alleen CompagnyID's. Wie
 * de andere partij is, is een gesprek tussen de organisaties — niet iets wat dit
 * scherm uit een andere omgeving ophaalt.
 *
 * ZWIJGEN ZOLANG HET NIET ZEKER IS. Leest een nog ladende lijst als 'niet
 * gedeeld', dan toont het scherm straks een tweede nulmeting aan een huishouden
 * dat er al één had, en die meting is achteraf niet te herstellen.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {string} props.adressID - `Adresses.ID` van dit huishouden
 */
const HouseholdChainNotice = ({ adressID }) => {
    const chain = useHouseholdChain(adressID)

    const sinds = useMemo(() => {
        if (!chain.firstRegisteredAt) return ''
        const datum = new Date(chain.firstRegisteredAt)
        return Number.isNaN(datum.getTime())
            ? ''
            : datum.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })
    }, [chain.firstRegisteredAt])

    if (!chain.loaded || !chain.shared) return null

    return (
        <p className='household-chain-notice'>
            Ook bekend bij een andere organisatie
            {sinds ? <> — in dit programma sinds <strong>{sinds}</strong></> : null}.
        </p>
    )
}

export default HouseholdChainNotice
